<template>
  <div
    :id="id"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-keyboard="false"
    data-backdrop="static">
    <div
      class="modal-dialog modal-md"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ $t('apps.inventory.message.binlocation') }}
          </h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="onClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div
            class="row"
            style="max-height: 60vh;overflow-y: auto;">
            <div
              v-for="(item, index) in form.items"
              :key="index"
              class="col-12 mb-2"
            >
              <div class="d-flex">
                <div
                  style="flex: 1;"
                  @click="onClickItem(index)">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{ $t('apps.inventory.message.bincodenumberorlocation') }}</span>
                    </div>
                    <input
                      v-model="item.code"
                      :class="['form-control text-right', { 'is-invalid': isDuplicated(index, item.code) }]"
                    >
                    <div class="invalid-feedback text-right">
                      {{ $t('apps.inventory.message.bincodecannotbedupplicated') }}
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-center align-items-center"
                  style="width: 40px;">
                  <BaseButton
                    v-if="form.items.length - 1 !== index"
                    className="no-bg"
                    @click="onOpenModal(index)"
                  >
                    <i class="far fa-trash-alt"/>
                  </BaseButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            @click="onCancel">{{ $t('button.cancel') }}</button>
          <button
            :disabled="duplicated"
            type="button"
            class="btn btn-web"
            @click="onSubmit">{{ $t('button.apply') }}</button>
        </div>
      </div>
    </div>

    <baseConfirmDeleteModal
      :show="modal.show"
      :loading="modal.loading"
      :description="$t('apps.inventory.message.confirmdeletebinlocation')"
      @onClose="handleCloseModal"
      @onCancel="handleCancleModal"
      @onSubmit="handleSumitModal"
    />
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import { cloneDeep } from 'lodash'

export default {
  props: {
    show: Boolean,
    loading: Boolean,
    binLocations: Array,
  },

  data () {
    return {
      form: {
        items: [],
      },
      formOriginal: null,
      modal: {
        show: false,
        loading: false,
        deleteIndex: null,
      },
    }
  },

  computed: {
    id () {
      return `${uuid.v1()}-bin-location-modal`
    },
    duplicated () {
      return this.form.items.some((item, index) => this.isDuplicated(index, item.code))
    },
  },

  watch: {
    show () {
      if (this.show) {
        $(`#${this.id}`).modal('show')
      } else {
        $(`#${this.id}`).modal('hide')
      }
    },
  },

  mounted () {
    this.setModal(`#${this.id}`)
    if (this.show) {
      $(`#${this.id}`).modal('show')
    }

    if (this.binLocations.length) {
      for (const bin of this.binLocations) {
        this.add({
          id: bin._id,
          code: bin.code,
        })
      }
      this.add()
    }

    if (this.form.items.length === 0) {
      this.add()
      this.add()
    }

    this.formOriginal = cloneDeep(this.form)
  },

  destroyed () {
    $(`#${this.id}`).remove()
  },

  methods: {
    onClose () {
      this.form = cloneDeep(this.formOriginal)
      this.$emit('onClose')
    },
    onCancel () {
      this.form = cloneDeep(this.formOriginal)
      this.$emit('onCancel')
    },
    onSubmit () {
      const items = this.form.items
        .filter((item) => item.code.trim())
        .reduce((acc, cur) => {
          const newItem = {
            ...cur,
          }
          const originItem = this.formOriginal.items.find((item) => item.code === cur.code)
          if (originItem) {
            newItem.id = originItem.id
          }
          acc.push(newItem)
          return acc
        }, [])
      this.$emit('onSubmit', items)
    },
    add (input = {}) {
      this.form.items.push({
        id: input.id || '',
        code: input.code || '',
      })
    },
    remove (index) {
      this.form.items.splice(index, 1)
    },
    onClickItem (index) {
      const isLast = this.form.items.length - 1 === index
      if (isLast) {
        this.add()
      }
    },
    isDuplicated (index, code) {
      return this.form.items.some((item, _index) => {
        const isEmpty = !item.code.trim() || !code.trim()
        const isEqual = item.code.trim() === code.trim()
        const isSelf = index === _index
        return !isEmpty && isEqual && !isSelf
      })
    },
    onOpenModal (deleteIndex) {
      const hasId = `${this.form.items[deleteIndex].id}`.length > 0
      if (hasId) {
        this.modal.show = true
        this.modal.deleteIndex = deleteIndex
      } else {
        this.remove(deleteIndex)
      }
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = false
      this.modal.show = false
      this.remove(this.modal.deleteIndex)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseBinLocationModal.vue